import { jsx } from 'react/jsx-runtime';
import { EGDSButton, EGDSTertiaryButton } from '@egds/react-core/button';
import { classNames, EGDSContextWrapper } from '@egds/react-core/utils';
import styles from '../../../../../styles/egds-lodging-tertiary-button-large-icon-with-text.css';

const getClassNameList = classNames.bind(styles);
const TertiaryButtonLargeIcon = (props) => {
    const { className, largeIcon, ...remaining } = props;
    const cssClassNames = getClassNameList(largeIcon ? `${EGDSButton.baseClassName}-tertiary-large-icon` : null, className);
    return (jsx(EGDSContextWrapper, { children: (context) => jsx(EGDSTertiaryButton, { ...remaining, className: cssClassNames, "data-context": context }) }));
};
TertiaryButtonLargeIcon.displayName = 'TertiaryButtonLargeIcon';

export { TertiaryButtonLargeIcon };
//# sourceMappingURL=index.esm.js.map
